import { useEffect } from "react";
import { BasicButton } from "./BasicButton";
import { BasicSwitch } from "./BasicSwitch";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _FormParamDinamic } from "../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { SelectTHConstantsValue } from "../../bpm/config/Componentes/SelectTHConstantsValue";
import { useObjectRenderer } from "../../system/remoteAbstractAction/hooks/useObjectRenderer";
import { PrintJson } from "./PrintJson";
import { Alert } from "./Alert";

interface Props {
  idFormType: number;
  handleUpdate: (bean: any) => void;
  modeTest?: boolean;
  data?: any
}

type inputParameter = {
  PropertyName: string,
  Label: string,
  FieldType: number,
  EditorObjectClassForName?: string,
  CodePar?: number,
}

export const RenderForm = ({ idFormType, handleUpdate, modeTest, data }: Props) => {
  const { instance, lista, setLista, bean, setBean } = useDataBean(_FormParamDinamic);
  const { renderInput: renderRemoteInput } = useObjectRenderer({ bean, setBean, idApplicationInvoker: null, data: bean ?? {} });

  useEffect(() => {
    if (idFormType) getProperties();
  }, [idFormType]);

  useEffect(() => {
    if (data) setBean(data);
  }, [data]);

  const getProperties = () => {
    instance.getFormAtributesByCode(idFormType).then((resp: any) => setLista(resp)).catch((err: any) => toast.error(err));
  };

  const renderInput = (parameter: inputParameter) => {

    const value = bean?.[parameter.PropertyName] ?? "";

    switch (parameter.FieldType) {
      case 1:
        return (
          <input
            type="text"
            className="form-control"
            value={value}
            onChange={(e) => setBean({ ...bean, [parameter.PropertyName]: e.target.value })}
          />
        );

      case 2:
        return (
          <input
            type="number"
            className="form-control"
            value={value}
            onChange={(e) => setBean({ ...bean, [parameter.PropertyName]: e.target.value })}
          />
        );

      case 3:
        return (
          <BasicSwitch
            estado={value}
            eventChange={(e: any) => setBean({ ...bean, [parameter.PropertyName]: String(e) })}
          />
        );

      case 4:
        return (
          <textarea
            className="form-control"
            value={value}
            onChange={(e) => setBean({ ...bean, [parameter.PropertyName]: e.target.value })}
          />
        );

      case 5:
        return (
          <SelectTHConstantsValue
            code={parameter.CodePar}
            value={value}
            onChange={(e: any) => setBean({ ...bean, [parameter.PropertyName]: e })}
          />
        );

      case 6:
        return (
          <input
            type="date"
            className="form-control"
            value={value}
            onChange={(e) => setBean({ ...bean, [parameter.PropertyName]: e.target.value })}
          />
        );

      // case 7:
      //   return <PrintJson json={} />;


      case 7:
        return renderRemoteInput({
          EditorObjectClassForName: parameter.EditorObjectClassForName,
          IDProperty: parameter.PropertyName,
          Name: undefined,
          Editable: true,

        });

      default:
        return (
          <input
            type="text"
            className="form-control"
            value={value}
            onChange={(e) => setBean({ ...bean, [parameter.PropertyName]: e.target.value })}
          />
        );
    }
  };

  const renderField = (campo: any) => {
    const props = campo?.DataBeanProperties;
    const key = props?.PropertyName ?? props?.Label ?? String(props?.CodePar ?? Math.random());

    return (
      <div key={key} className={`col-md-${props?.ColumnSize ?? 12}`}>
        <>
          {props?.Label &&
            <label>
              {props?.Label}
              {props?.RequiredCamp && <span className="text-danger"> *</span>}
            </label>
          }
        </>
        {renderInput(props)}
      </div>
    );
  };

  const saveBean = () => {
    if (!validateRequiredFields()) return;
    handleUpdate(bean);
  };

  const orderedList = [...lista].sort((a: any, b: any) => {
    const aIndex = a?.DataBeanProperties?.IndexContinuity;
    const bIndex = b?.DataBeanProperties?.IndexContinuity;

    if (aIndex != null && bIndex != null) return aIndex - bIndex;

    if (aIndex != null) return -1;

    if (bIndex != null) return 1;
    return 0;
  });

  const validateRequiredFields = () => {
    const missingFields: string[] = [];

    orderedList.forEach((campo: any) => {
      const props = campo?.DataBeanProperties;
      if (!props?.RequiredCamp) return;

      const name = props.PropertyName;
      const value = bean?.[name];

      const isEmpty =
        value === null ||
        value === undefined ||
        value === "" ||
        (Array.isArray(value) && value.length === 0);

      if (isEmpty) {
        missingFields.push(props.Label || name);
      }
    });

    if (missingFields.length > 0) {
      toast.error(
        `Campos obligatorios sin diligenciar:\n• ${missingFields.join("\n• ")}`
      );
      return false;
    }

    return true;
  };

  return (
    <div className="row">
      {/* <PrintJson json={bean} /> */}
      <div className="col-md-12">
        {modeTest && (
          <BasicButton icon="ri-refresh-line" clase="warning" eventClick={getProperties}>
            Actualizar
          </BasicButton>
        )}
      </div>

      <div className="col">
        <div className="row">
          {orderedList.length > 0 ?
            orderedList.map(renderField)
            :
            <Alert clase="info" children={"Sin Datos que mostrar"} />
          }
        </div>

        <div className="row">
          <div className="col-md-6">
            {orderedList.length > 0 && (
              <BasicButton useMargin icon="ri-save-line" eventClick={saveBean}>
                Guardar
              </BasicButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
